@switch (slot()) {
@case ('canBuy') {
@if (declinedReasonLabel()) {
<p class="text-left text-xs font-semibold text-zinc-500" data-testid="license-declined-note">
    Last request declined · {{ declinedReasonLabel() }}
</p>
}
<!-- <button type="button" (click)="buy.emit()" data-testid="license-buy" class="license-buy-btn inline-flex h-11 w-full items-center justify-center gap-2 rounded-lg text-sm font-extrabold text-white"> -->
<button type="button" (click)="buy.emit()" data-testid="license-buy" class="primary-button-full inline-flex items-center justify-center flex-1 gap-x-1.5 rounded-full bg-primary px-2.5 py-1.5 text-sm font-medium text-white shadow-sm hover:bg-primary/90">
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="m3 11 18-5v12L3 14v-3z" />
        <path d="M11.6 16.8a3 3 0 1 1-5.8-1.6" />
    </svg>
    License 1 · {{ quotePrice() | currency: currency() }}
</button>
}
@case ('expired') {
<p class="text-left text-xs font-semibold text-zinc-500" data-testid="license-expired-note">
    License expired {{ license()?.expiresAt | date: 'd MMM yyyy' }}
</p>
<button type="button" (click)="buy.emit()" data-testid="license-buy"
    class="license-buy-btn inline-flex h-11 w-full items-center justify-center gap-2 rounded-lg text-sm font-extrabold text-white">
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="m3 11 18-5v12L3 14v-3z" />
        <path d="M11.6 16.8a3 3 0 1 1-5.8-1.6" />
    </svg>
    License 2 · {{ quotePrice() | currency: currency() }}
</button>
}
@case ('pending') {
<div class="flex flex-col gap-0.5 rounded-lg bg-[#E7E6EA] px-3 py-2.5 text-left dark:bg-zinc-800"
    data-testid="license-pending">
    <span class="text-sm font-extrabold text-[#2B2340] dark:text-white">Awaiting creator approval</span>
    <span class="text-xs font-semibold text-[#58516A] dark:text-zinc-300">{{ licensePrice() | currency:
        currency() }} paid · refunded if declined</span>
    <button type="button" (click)="cancel.emit()"
        class="mt-1 self-start text-xs font-bold text-[#6508FB] underline underline-offset-2 hover:text-[#843AFB] dark:text-violet-300">Cancel
        request</button>
</div>
}
@case ('licensed') {
<div class="flex flex-col gap-0.5 rounded-lg bg-[#F0E6FE] px-3 py-2.5 text-left dark:bg-violet-900/30"
    data-testid="license-licensed">
    <span class="text-sm font-extrabold text-[#7421FB] dark:text-violet-300">Licensed for boosting &amp; dark
        ads</span>
    <span class="text-xs font-semibold text-[#58516A] dark:text-zinc-300">Valid until {{ license()?.expiresAt |
        date: 'd MMM yyyy' }}</span>
</div>
}
@case ('locked') {
<div class="flex h-11 items-center justify-center rounded-lg border border-dashed border-black/14 text-xs font-bold text-zinc-500 dark:border-white/20"
    data-testid="license-locked">
    Ad License available once approved
</div>
}
}